export default __webpack_public_path__ + "static/media/930.52e46bca.png";